export default "__VITE_ASSET__zSuuNl3T__"